import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-K5TG5EXSB1");
};


export const captureTrafficSource = () => {
  if (typeof window === "undefined") return;
  if (typeof localStorage === "undefined") return;
  if (localStorage.getItem("traffic_source")) return;

  const url = new URL(window.location.href);

  const sourceData = {
    utm_source: url.searchParams.get("utm_source") || document.referrer || "direct",
    utm_medium: url.searchParams.get("utm_medium") || "unknown",
    utm_campaign: url.searchParams.get("utm_campaign") || "none",
    referrer: document.referrer || "direct",
  };

  localStorage.setItem("traffic_source", JSON.stringify(sourceData));
};


export const trackPage = (path) => {
  let source = {};
  try {
    source = JSON.parse(localStorage.getItem("traffic_source") || "{}");
  } catch {}

  ReactGA.send({
    hitType: "pageview",
    page: path,
    title: document.title,
    location: window.location.href,
    referrer: source.referrer || document.referrer || "direct",
    utm_source: source.utm_source || "direct",
    utm_medium: source.utm_medium || "unknown",
    utm_campaign: source.utm_campaign || "none",
  });
};

